<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

// import Profile from "@/components/widgets/profile";
// import Earning from "@/components/widgets/earning";
// import Stat from "@/components/widgets/stat";
// import Transaction from "@/components/widgets/transaction";
// import Emailsent from "@/components/widgets/emailsent";
// import SocialSource from "@/components/widgets/social-source";
// import Activity from "@/components/widgets/activity";
// import SellingProduct from "@/components/widgets/selling-product";

import MyTickets from "./widgets/MyTickets";
import MyTasks from "./widgets/MyTasks";
import ClaimableTickets from './widgets/ClaimableTickets.vue';
import UnassignedTickets from './widgets/UnassignedTickets.vue';
// import UnresolvedSlaBreaches from "./widgets/UnresolvedSlaBreaches";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // UnresolvedSlaBreaches,
    Layout,
    PageHeader,
    // Profile,
    // Stat,
    // Transaction,
    // Earning,
    // Emailsent,
    // SocialSource,
    // Activity,
    // SellingProduct,

    MyTickets,
    MyTasks,
    ClaimableTickets,
    UnassignedTickets
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        // {
        //     text: "Dashboard",
        //     href: "#",
        // },
        // {
        //     text: "Default",
        //     active: true,
        // },
      ]
    };
  },
  mounted() {
  },
};
</script>

<template>
  <Layout>
<!--    <PageHeader :title="title" :items="items"/>-->
    <div class="row">
      <div class="col-xl-12">
        <my-tickets></my-tickets>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-xl-12">
        <claimable-tickets></claimable-tickets>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-xl-12">
        <unassigned-tickets></unassigned-tickets>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-xl-12">
        <my-tasks></my-tasks>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
<!--          <unresolved-sla-breaches></unresolved-sla-breaches>-->
      </div>
    </div>
  </Layout>
</template>
